import Cookies from 'js-cookie'

let isAgreedLS = !! localStorage.getItem('ia_cookies_policy_accepted')

if (! isAgreedLS) {
  if (Cookies.get('ia_cookies_policy_accepted')) {
    isAgreedLS = Cookies.get('ia_cookies_policy_accepted')
  } else if (document.body.classList.contains('logged-in')) {
    isAgreedLS = Date.now()
  }

  if (isAgreedLS) {
    localStorage.setItem('ia_cookies_policy_accepted', isAgreedLS)
  }
}

export default {
  computed: {
    isAgreed() {
      return !! localStorage.getItem('ia_cookies_policy_accepted')
    },
  },

  methods: {
    agree() {
      localStorage.setItem('ia_cookies_policy_accepted', Date.now())
      Cookies.set('ia_cookies_policy_accepted', Date.now(), { expires: 365 * 3 })

      this.$el.parentNode.removeChild(this.$el)
    },
  }
}


// WEBPACK FOOTER //
// ./src/controllers/gdpr_cookie.js